// extracted by mini-css-extract-plugin
export default {"metaDataCard":"meta-data-card_metaDataCard__Ij3gd"};